const mobileMaxWidth = 767;

export const isMobile = (): boolean => {
    if (typeof window !== 'undefined') {
        return window.innerWidth <= mobileMaxWidth;
    }
    return false;
};
